import { render, staticRenderFns } from "./DoctorsDialog.vue?vue&type=template&id=7bf3ebe8"
import script from "./DoctorsDialog.vue?vue&type=script&lang=js"
export * from "./DoctorsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports